import {
    Box, Flex, HStack, Text,
    TextProps,
} from '@chakra-ui/react';

const FALLBACK_COLOR = 'muted.100';

export function GraphLegend({
    data,
    ...props
}: {
    data: {
        label?: string | number;
        legendIconColor: string | null;
    }[];
} & TextProps) {
    if (data.length === 0) return null;

    return (
        <Flex flexWrap="wrap" justify="center">
            {
                data.map((item) => (
                    <HStack key={`${item.label}-${item.legendIconColor}`} px={4} py={1} gap={1.5}>
                        <Box w={2.5} h={2.5} bgColor={item.legendIconColor ?? FALLBACK_COLOR} borderRadius="full" />
                        <Text fontSize="xs" color="charcoal.500" {...props}>
                            {item.label ?? ''}
                        </Text>
                    </HStack>
                ))
            }
        </Flex>
    );
}
